import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "packing-groups" }
const _hoisted_2 = { class: "packing-groups__group" }
const _hoisted_3 = { class: "packing-groups__label" }
const _hoisted_4 = { class: "packing-groups__children" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_label_box = _resolveComponent("label-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packingGroups, (group) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(group.group), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (child) => {
            return (_openBlock(), _createBlock(_component_label_box, {
              label: child,
              "model-value": child
            }, null, 8, ["label", "model-value"]))
          }), 256))
        ])
      ]))
    }), 256))
  ]))
}